import script from "./PictureCardAmplifier.vue?vue&type=script&setup=true&lang=js"
export * from "./PictureCardAmplifier.vue?vue&type=script&setup=true&lang=js"

import "./PictureCardAmplifier.vue?vue&type=style&index=0&id=256a6bb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256a6bb6"]])

export default __exports__